document.addEventListener('DOMContentLoaded', function () {
  // Accordions
  document.querySelectorAll('.description-toggle').forEach(function (container) {
    container.addEventListener('click', function () {
      const targetId = this.querySelector('.toggle-btn').dataset.target;
      const targetElement = document.getElementById(targetId);
      const button = this.querySelector('.toggle-btn');

      if (targetElement.style.maxHeight) {
        targetElement.style.maxHeight = null;
        button.style.transform = 'rotate(0)';
        this.classList.remove('active');
      } else {
        targetElement.style.maxHeight = targetElement.scrollHeight + 'px';
        button.style.transform = 'rotate(180deg)';
        this.classList.add('active');
      }
    });
  });

  // Thumbnail gallery
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainImage = document.getElementById('productMainImage');

  if (thumbnails.length && mainImage) {
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbnails.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        mainImage.src = this.dataset.src;
        mainImage.srcset = this.dataset.srcset;
      });
    });
  }
});
